"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M15 1a1 1 0 011 1v12a1 1 0 01-1 1H1a1 1 0 01-1-1V2a1 1 0 011-1h14zm-1 4H2v8h12V5zm-3-3H9v2h2V2zm3 0h-2v2h2V2z"];
//# sourceMappingURL=modal.js.map